import { initI18n } from '@wix/fe-essentials/i18n';
const getEditorMessages = async (locale, editorHost) => {
  try {
    return await import(`../assets/locale/${editorHost}/messages_${locale}.json`);
  } catch (error) {
    return {};
  }
};
const getCommonMessages = async locale => {
  try {
    return await import(`../assets/locale/common/messages_${locale}.json`);
  } catch (error) {
    return {};
  }
};
export const getMessages = async (locale, editorHost) => {
  const [commonMessages, editorMessages] = await Promise.all([getCommonMessages(locale), getEditorMessages(locale, editorHost)]);
  return {
    ...commonMessages,
    ...editorMessages
  };
};
export const initializeI18n = (locale, editorHost, options) => initI18n({
  ...options,
  asyncMessagesLoader: () => getMessages(locale, editorHost),
  bindI18n: 'languageChanged',
  locale,
  useSuspense: true
});
//# sourceMappingURL=i18n.js.map